'use client';

import React, { useState } from 'react';
import Image from 'next/image';
import { QuizStep } from '../../lib/quiz-definition';

interface StatementStepProps {
    step: QuizStep;
    onNext: (nextStepId: string) => void;
    basePath: string;
}

const StatementStep: React.FC<StatementStepProps> = ({ step, onNext, basePath }) => {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleEmailSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        console.log("Email submitted:", email);
        // TODO: Add logic to send email to backend/mailing list
        setSubmitted(true);
    };

    return (
        <div className="quiz-step statement-step-content">
            {/* Wrapper for main content */}
            <div className="statement-content-main">
                {step.imageUrl && (
                    <Image 
                        src={`${basePath}${step.imageUrl}`}
                        alt="Statement visual" 
                        className="quiz-statement-image" 
                        width={200}
                        height={150}
                        loading="lazy"
                    />
                )}
                {step.title && (
                    <h1 className="quiz-header-title text-center">{step.title}</h1>
                )}
                <p className="quiz-statement-text">{step.content}</p>
            </div>
            
            {/* Wrapper for button/form area */}
            <div className="statement-button-wrapper">
                {/* Conditional Email Form */}
                {step.requiresEmailForm ? (
                    submitted ? (
                        <p className="quiz-email-thanks">Thanks! We'll be in touch.</p>
                    ) : (
                        <form onSubmit={handleEmailSubmit} className="quiz-email-form">
                            <input 
                                type="email" 
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="quiz-email-input"
                            />
                            <button type="submit" className="quiz-email-button">
                                Join our waiting list
                            </button>
                        </form>
                    )
                ) : (
                    // Show Continue button only if NOT showing email form and nextStepId exists
                    step.nextStepId && (
                        <button onClick={() => onNext(step.nextStepId!)} className="quiz-footer-button">
                            Continue
                        </button>
                    )
                )}
            </div>
        </div>
    );
};

export default StatementStep; 